import { Definition } from "../../../data/Definition";
import { Crop, Variety } from "../types/types";

export type State = {
    crops: Crop[],
    varieties: Variety[],
    definitions: Definition[],
};
  
export const initialState: State = {
    crops: [],
    varieties: [],
    definitions: []
};
